import AppService from './AppService';

class UserService extends AppService {

  constructor() {
    super();
    this.path = this.getPath('users');
  }

  create(data) {
    return this.http.post(`${this.path}`, data);
  }

  read(id) {
    return this.http.get(`${this.path}/${id}`);
  }

  update(data, id) {
    return this.http.patch(`${this.path}/${id}`, data);
  }

  delete(id) {
    return this.http.delete(`${this.path}/${id}`);
  }

  list(params = '') {
    const queryParams = params ? params : '';
    return this.http.get(`${this.path}${queryParams}`);
  }

  me() {
    return this.http.get(`${this.path}/me`);
  }

  verifyEmail(search) {
    return this.http.get(`${this.path}/verify/email?${search}`);
  }
}

export default UserService;
